import * as React from "react";
import QuoteDetails from "../../model/quote/QuoteDetails";
import {none, Option, some} from "ts-option";
import {RouteComponentProps} from "react-router";
import {api} from "../../api/api";
import {notifyBugsnagAndShowToast} from "../../utils/Utils";
import QuoteDetailsBody from "./QuoteDetailsBody";
import {RootState} from "../../store/reducer/root/RootState";
import {getLeadByIdOrRefNo} from "../../store/view/lead";
import {getIndividualContact} from "../../store/view/contact";
import {connect, Dispatch} from "react-redux";
import {OnFailure, OnSuccess} from "../../store/action/actionHelpers";
import {fetchLeadByRefNo} from "../../store/action/lead/lead";
import {withRouter} from "react-router-dom";
import Lead from "../../model/lead/Lead";
import IndividualContact from "../../model/contact/IndividualContact";
import Routes from "../../navigation/route/Route";
import {noop} from "react-select/lib/utils";

interface State {
	quoteDetails: Option<QuoteDetails>
}

interface RouteProps {
	/**
	 * Quote identifier.
	 */
	quoteId: string;
	/**
	 * Quote version number
	 */
	versionNumber: number
	/**
	 * Lead ref number
	 */
	leadReferenceNumber: string
}

interface ReduxProps {
	/**
	 * Lead data.
	 */
	lead: Option<Lead>;
	/**
	 * Lead contact data.
	 */
	contact: Option<IndividualContact>;
}

interface DispatchProps {
	fetchLeadByRefNumber: (leadRefNumber: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

type Props = RouteComponentProps<RouteProps> & ReduxProps & DispatchProps

class QuoteDetailsWithVersion extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {quoteDetails: none}
	}

	componentDidMount() {
		const {quoteId, versionNumber} = this.props.match.params
		api.instance.quoteApi.fetchQuoteDetails(quoteId, versionNumber)
			.then(qd => this.setState({quoteDetails: some(qd)}))
			.catch(e => {
				notifyBugsnagAndShowToast(e, "Fetch quote details");
				this.onBack()
			});
		if (this.props.match.params.leadReferenceNumber && this.props.lead.isEmpty) {
			this.props.fetchLeadByRefNumber(this.props.match.params.leadReferenceNumber, noop,
				(err) => notifyBugsnagAndShowToast(err, "Fetch lead"))
		}
	}

	render() {
		const refNumPathItem1 = this.props.lead.map(l => `Lead ID# ${l.referenceNumber}`).orNull;
		return <QuoteDetailsBody quoteDetails={this.state.quoteDetails}
								 isLoading={this.state.quoteDetails.isEmpty}
								 refNumPathItem1={refNumPathItem1}
								 onBack={this.onBack}
								 contact={this.props.contact}
								 readonly/>
	}

	onBack = () => {
		const params = this.props.match.params;
		this.props.history.push(Routes.EditLead(params.leadReferenceNumber))
	}
}

function mapStateToProps(state: RootState, props: Props) {
	const lead = getLeadByIdOrRefNo(props.match.params.leadReferenceNumber, state);
	const contactId = lead.map(l => l.data.principalContactId)
	const contact = contactId.flatMap(id => getIndividualContact(id, state));
	return ({lead, contact});
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchLeadByRefNumber: (jobRefNumber: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			fetchLeadByRefNo(jobRefNumber, onSuccess, onFailure)),
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuoteDetailsWithVersion))